import { AppRouter } from "./router/AppRouter";
import { AppTheme } from "./theme/AppTheme";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { Loader } from "./ars/loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigCatProvider } from "configcat-react";
import { ErrorBoundary } from "./telemetry/ErrorBoundary";
import { AppInsightsGate } from "./telemetry/AppInsightsGate";

export const App = () => {
  const msalInstance = new PublicClientApplication(msalConfig);

  return (
    // ErrorBoundary reports any uncaught render error, anywhere in the app,
    // to App Insights. AppInsightsGate starts the App Insights SDK itself,
    // once the enableTelemetry ConfigCat flag resolves.
    <ErrorBoundary>
      <ConfigCatProvider sdkKey={process.env.REACT_APP_CONFIG_CAT || ""}>
        <AppInsightsGate>
          <MsalProvider instance={msalInstance}>
            <Loader>
              <AppTheme>
                <AppRouter />
              </AppTheme>
            </Loader>
            <ToastContainer autoClose={3000} hideProgressBar={true} />
          </MsalProvider>
        </AppInsightsGate>
      </ConfigCatProvider>
    </ErrorBoundary>
  );
};
